import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { ACCOUNT_TEAMS } from './actions';

export const reducers = createReducer(
	initialState,
	on(ACCOUNT_TEAMS.USERS_LIST.GET, (state, action: any) => ({
		...state,
		loading: true,
	})),
	on(ACCOUNT_TEAMS.USERS_LIST.FAILURE, (state, action: any) => ({
		...state,
		loading: false,
		error: action.payload.message,
	})),
	on(ACCOUNT_TEAMS.USERS_LIST.SUCCESS, (state, action: any) => ({
		...state,
		loading: false,
		usersList: action.data,
		total: action.numberOfResults,
	})),
	// set data
	on(ACCOUNT_TEAMS.SET.FILTER_LIST, (state, action: { filtersList: any[] }) => ({
		...state,
		filters: action.filtersList,
	})),
	on(ACCOUNT_TEAMS.SET.SORT_LIST, (state, action: { sortList: any[] }) => ({
		...state,
		sort: action.sortList,
	})),
	on(ACCOUNT_TEAMS.SET.PAGE, (state, { currentPage }) => ({
		...state,
		currentPage,
	})),
	on(ACCOUNT_TEAMS.SET.PAGE_SIZE, (state, { pageSize }) => ({
		...state,
		pageSize,
	})),

	// reset state
	on(ACCOUNT_TEAMS.RESET_STATE, (state) => ({
		...initialState,
	})),

	// activate user
	on(ACCOUNT_TEAMS.ACTIVATE_USER.SUCCESS, (state, action: any) => ({
		...state,
		usersList: state.usersList.map((user) => (user.id === action.user.id ? action.user : user)),
	})),

	// deactivate user
	on(ACCOUNT_TEAMS.DEACTIVATE_USER.SUCCESS, (state, action: any) => ({
		...state,
		usersList: state.usersList.map((user) => (user.id === action.user.id ? action.user : user)),
	})),

	// update user role
	on(ACCOUNT_TEAMS.UPDATE_USER_ROLE.SUCCESS, (state, action: any) => ({
		...state,
		usersList: state.usersList.map((user) => (user.id === action.user.id ? action.user : user)),
	})),

	// set email recipient
	on(ACCOUNT_TEAMS.SET_EMAIL_RECIPIENT.SUCCESS, (state, action: any) => ({
		...state,
		usersList: state.usersList.map((user) => (user.id === action.user.id ? action.user : user)),
	}))
);
